// src/hooks/useMyPantry.js  —  ohapotato v2026.10.36
//
// Stores what the user already has at home.
// Available to ALL users (free + premium) — no auth required.
// Persisted to localStorage under 'ohp-my-pantry'.
// Returns a Set of ingredient IDs.

import { useState, useCallback, useEffect } from 'react';

const KEY = 'ohp-my-pantry';

function load() {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) || '[]')); }
  catch { return new Set(); }
}

function save(set) {
  try { localStorage.setItem(KEY, JSON.stringify([...set])); } catch {}
}

export function useMyPantry() {
  const [pantry, setPantry] = useState(load);

  useEffect(() => { save(pantry); }, [pantry]);

  const addToPantry = useCallback((id) => {
    setPantry(prev => { const n = new Set(prev); n.add(id); return n; });
  }, []);

  const removeFromPantry = useCallback((id) => {
    setPantry(prev => { const n = new Set(prev); n.delete(id); return n; });
  }, []);

  const togglePantry = useCallback((id) => {
    setPantry(prev => {
      const n = new Set(prev);
      if (n.has(id)) n.delete(id); else n.add(id);
      return n;
    });
  }, []);

  const clearPantry = useCallback(() => setPantry(new Set()), []);

  // Returns pantry item labels for use in meal planning
  const getPantryLabels = useCallback((ingredients) => {
    return ingredients.filter(i => pantry.has(i.id)).map(i => i.label);
  }, [pantry]);

  return { pantry, addToPantry, removeFromPantry, togglePantry, clearPantry, getPantryLabels };
}
